<template>
  <svg width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.69 6.81c-.242-2.448-2.445-4.238-4.905-4.238H5.143V.429a.43.43 0 00-.696-.335L.16 3.522a.43.43 0 000 .67l4.285 3.429a.433.433 0 00.454.051.43.43 0 00.243-.386V5.143h3.733c1.121 0 2.143.806 2.255 1.92A2.144 2.144 0 019 9.43H5.57a.429.429 0 00-.428.428v1.714c0 .237.192.429.428.429H9a4.722 4.722 0 004.69-5.19"
      fill="#231F20"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBack',
};
</script>

<style></style>
